(() => {
  if (customElements.get('basic-preset-builder')) return;

  class BasicPresetBuilder extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-preset-variants]').textContent);
      const linkedVariant = this.variants.find((variant) => String(variant.id) === new URLSearchParams(location.search).get('variant'));
      const selected = linkedVariant || this.variants.find((variant) => variant.available) || this.variants[0];
      this.selection = [...selected.options];
      if (!linkedVariant) this.selection[1] = '';
      this.money = new Intl.NumberFormat('ms-MY', { style: 'currency', currency: this.dataset.currency || 'MYR' });
      this.setButtons = [...this.querySelectorAll('.ba-preset__set')];
      this.sizeButtons = [...this.querySelectorAll('.ba-preset__size')];
      this.addButton = this.querySelector('[data-add]');
      this.error = this.querySelector('[data-error]');

      this.setButtons.forEach((button) => button.addEventListener('click', () => this.choose(0, button.dataset.optionValue)));
      this.sizeButtons.forEach((button) => button.addEventListener('click', () => this.choose(1, button.dataset.optionValue)));
      this.addButton.addEventListener('click', () => this.addToCart());
      this.render();
    }

    choose(index, value) {
      if (this.busy) return;
      this.selection[index] = value;
      this.hideError();
      this.render();
      if (index === 0) this.previewSelectedSet();
    }

    currentVariant() {
      return this.variants.find((variant) => variant.options.every((value, index) => value === this.selection[index]));
    }

    render() {
      const variant = this.currentVariant();
      this.setButtons.forEach((button) => {
        const selected = button.dataset.optionValue === this.selection[0];
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', String(selected));
      });
      this.sizeButtons.forEach((button) => {
        const value = button.dataset.optionValue;
        const selected = value === this.selection[1];
        const available = this.variants.some((item) => item.options[0] === this.selection[0] && item.options[1] === value && item.available);
        button.classList.toggle('is-selected', selected);
        button.classList.toggle('is-unavailable', !available);
        button.setAttribute('aria-checked', String(selected));
        button.setAttribute('aria-disabled', String(!available));
        button.disabled = !available;
      });
      this.querySelector('[data-current-set]').textContent = this.selection[0];
      const size = this.selection[1] || 'Pilih saiz dahulu';
      const price = this.money.format((variant?.price ?? selectedPrice(this.variants, this.selection[0])) / 100);
      this.querySelector('[data-current-size]').textContent = size;
      this.querySelector('[data-selection-summary]').textContent = `7 helai · ${this.selection[0]} · ${size}`;
      this.querySelector('[data-preset-total]').textContent = price;
      this.addButton.disabled = Boolean(this.selection[1]) && !variant?.available;
      this.addButton.textContent = !this.selection[1] ? 'Pilih saiz dahulu' : variant?.available ? `Tambah ke troli — ${price}` : 'Pilihan ini kehabisan stok';
      this.dataset.selectionSummary = `7 Helai · ${price}`;
      this.dispatchEvent(new CustomEvent('basic-bundle:selection', { bubbles: true }));
      if (variant && !variant.available) this.showError(`${this.selection[0]} · ${this.selection[1]} kehabisan stok. Sila pilih saiz lain.`);
    }

    previewSelectedSet() {
      const variant = this.variants.find((item) => item.options[0] === this.selection[0] && (item.featured_media || item.featured_image));
      const mediaId = variant?.featured_media?.id;
      const gallery = document.querySelector('media-gallery');
      const media = mediaId ? gallery?.querySelector(`[data-media-id$="-${mediaId}"]`) : null;
      if (media?.dataset.mediaId && gallery?.setActiveMedia) gallery.setActiveMedia(media.dataset.mediaId, true, false);
    }

    async addToCart() {
      if (this.busy) return;
      if (!this.selection[1]) {
        this.showError('Sila pilih saiz anda sebelum menambah ke troli.');
        this.sizeButtons.find((button) => !button.disabled)?.focus();
        return;
      }
      const variant = this.currentVariant();
      if (!variant?.available) {
        this.showError(`${this.selection[0]} · ${this.selection[1]} kehabisan stok. Sila pilih pilihan lain.`);
        return;
      }
      this.addButton.disabled = true;
      this.busy = true;
      this.addButton.textContent = 'Menambah ke troli…';
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Tidak dapat menambah ke troli.');
        this.addButton.textContent = 'Sudah ditambah ✓';
        window.setTimeout(() => window.location.assign(this.dataset.cartUrl), 350);
      } catch (error) {
        this.busy = false;
        this.showError(error.message || 'Tidak dapat menambah ke troli. Sila cuba lagi.');
        this.addButton.disabled = false;
        this.render();
      }
    }

    showError(message) { this.error.textContent = message; this.error.hidden = false; }
    hideError() { this.error.hidden = true; this.error.textContent = ''; }
  }

  customElements.define('basic-preset-builder', BasicPresetBuilder);
  function selectedPrice(variants, set) {
    return (variants.find((variant) => variant.options[0] === set) || variants[0]).price;
  }
})();
